/** Mini mise en forme pour les textes rédigés dans l'admin :
 *  **gras**, *italique*, retour à la ligne = <br/>, ligne vide = nouveau paragraphe.
 *  Aucun HTML interprété : le texte saisi est affiché tel quel, sans risque. */
function renderInline(text, keyPrefix) {
  const out = [];
  let k = 0;
  text.split(/\*\*([^*]+)\*\*/g).forEach((chunk, i) => {
    if (i % 2 === 1) {
      out.push(<strong key={`${keyPrefix}-b${k++}`}>{chunk}</strong>);
      return;
    }
    chunk.split(/\*([^*]+)\*/g).forEach((c, j) => {
      if (j % 2 === 1) out.push(<em key={`${keyPrefix}-i${k++}`}>{c}</em>);
      else if (c) out.push(c);
    });
  });
  return out;
}

export default function RichText({ text, className = "" }) {
  const paragraphs = (text || "").split(/\n\s*\n/).filter((p) => p.trim());
  return (
    <div className={className}>
      {paragraphs.map((p, i) => (
        <p key={i} className={i > 0 ? "mt-4" : ""}>
          {p
            .trim()
            .split("\n")
            .flatMap((line, j) => (j === 0 ? [renderInline(line, `${i}-${j}`)] : [<br key={`${i}-br${j}`} />, renderInline(line, `${i}-${j}`)]))}
        </p>
      ))}
    </div>
  );
}
